module.exports = __webpack_public_path__ + "static/media/followthewhiterabbit.a6633af3.gif";